import { render, staticRenderFns } from "./ClearGoods.vue?vue&type=template&id=59273fd0"
import script from "./ClearGoods.vue?vue&type=script&lang=js"
export * from "./ClearGoods.vue?vue&type=script&lang=js"
import style0 from "./ClearGoods.vue?vue&type=style&index=0&id=59273fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports